import { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { Icon } from '../../../layout/Icon.jsx';
import { copyText } from '../platformApi.js';
import { toast } from '../../../shared/useToast.js';

/** زر نسخ — يُظهر ✓ لحظة النسخ. */
export function CopyBtn({ value, label = 'نسخ', title = 'نسخ', className = 'btn btn-sm' }) {
  const [done, setDone] = useState(false);
  const timer = useRef(null);

  useEffect(() => () => { if (timer.current) clearTimeout(timer.current); }, []);

  async function onCopy() {
    const ok = await copyText(value);
    if (!ok) {
      toast.error('تعذّر النسخ — انسخ النص يدوياً');
      return;
    }
    setDone(true);
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => setDone(false), 1600);
  }

  return (
    <button type="button" className={clsx(className, done && 'btn-success')} onClick={onCopy} title={title}>
      {done ? <Icon name="check" size={13} /> : null}
      {done ? 'تم النسخ' : label}
    </button>
  );
}
